import { createAction } from '@reduxjs/toolkit';
export const DELETE_CONTACT = 'DELETE_CONTACT';
export const deleteContactAction = createAction(DELETE_CONTACT, (contactId) => ({
  payload: { contactId }
}));